export const MEDIA = {
  hero: "https://customer-assets.emergentagent.com/job_moonlit-coast/artifacts/vchloxch_Untitled-2.jpg",
  album: "https://static.prod-images.emergentagent.com/jobs/ba1cbe27-92c4-4914-9557-c3852065df84/images/ab4ad0f644a8bf0a9dbf44d6824275d505f9e000d6cb01b93599883904041ad0.png",
  diary: "https://static.prod-images.emergentagent.com/jobs/ba1cbe27-92c4-4914-9557-c3852065df84/images/cafcbb9a9d96a977156ccdd81fbf96ba422d4474e8c07ffc4ec00acfdcc11bc4.png",
  gallery: [
    {
      url: "https://customer-assets.emergentagent.com/job_moonlit-coast/artifacts/6oe5sx92_IMG_2916.jpg",
      caption: "Portrait, in transit",
    },
    {
      url: "https://customer-assets.emergentagent.com/job_moonlit-coast/artifacts/ttb8zpa9_IMG_3040.jpg",
      caption: "By the river, late afternoon",
    },
    {
      url: "https://customer-assets.emergentagent.com/job_moonlit-coast/artifacts/iw844k74_IMG_3167.jpg",
      caption: "Riverside ride",
    },
  ],
};
